import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerBillingInvoiceListComponent } from './customer-billing-invoice-list/customer-billing-invoice-list.component';
import { InvoiceService } from './invoice.service';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ComponentsModule } from '@fi-app/components/components.module';
import { CustomerBillingInvoiceViewComponent } from './customer-billing-invoice-view/customer-billing-invoice-view.component';
import { CustomerBillingInvoiceViewInvoiceComponent } from './customer-billing-invoice-view-invoice/customer-billing-invoice-view-invoice.component';
import { CustomerBillingInvoiceCreateDialogComponent } from './customer-billing-invoice-create-dialog/customer-billing-invoice-create-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { CustomerBillingInvoiceEditDialogComponent } from './customer-billing-invoice-edit-dialog/customer-billing-invoice-edit-dialog.component';
import { CustomerBillingInvoiceEditInvoiceComponent } from './customer-billing-invoice-edit-invoice/customer-billing-invoice-edit-invoice.component';
import { CustomerBillingInvoiceEditStateComponent } from './customer-billing-invoice-edit-state/customer-billing-invoice-edit-state.component';
import { FormsModule } from '@angular/forms';
import { AutocompleteModule } from '@fi-app/utilities/autocomplete/autocomplete.module';
import { CustomerBillingInvoiceListStateComponent } from './customer-billing-invoice-list/customer-billing-invoice-list-state.component';
import { InvoiceStatusListItemComponent } from './invoice-status-list-item/invoice-status-list-item.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomerBillingInvoiceBankInfoComponent } from './customer-billing-invoice-bank-info/customer-billing-invoice-bank-info.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        MatDialogModule,
        MatRadioModule,
        AutocompleteModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        SelectSearchModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    declarations: [
        CustomerBillingInvoiceListComponent,
        CustomerBillingInvoiceViewComponent,
        CustomerBillingInvoiceViewInvoiceComponent,
        CustomerBillingInvoiceCreateDialogComponent,
        CustomerBillingInvoiceEditDialogComponent,
        CustomerBillingInvoiceEditInvoiceComponent,
        CustomerBillingInvoiceEditStateComponent,
        CustomerBillingInvoiceListStateComponent,
        InvoiceStatusListItemComponent,
        CustomerBillingInvoiceBankInfoComponent,
    ],
    providers: [InvoiceService],
})
export class CustomerBillingInvoiceModule {}
